import React, { FunctionComponent } from "react";
import { TextField, Typography, Box } from "@mui/material";

import Autocomplete from "@mui/material/Autocomplete";
import { useQuery } from "@apollo/client";

import { GET_EMAIL_TEMPLATES } from "../../api/graphql";
import { Skeleton } from "@mui/material";

type EmailTemplateAutocompleteProps = {
  value?: any;
  onChange?: (e: React.ChangeEvent<{}>, value: any) => void;
};
const EmailTemplateAutocomplete: FunctionComponent<
  EmailTemplateAutocompleteProps
> = ({ value, onChange }) => {
  const { data, loading } = useQuery(GET_EMAIL_TEMPLATES);

  const renderOption = (props: any, option: any) => {
    return (
      <Box
        component="li"
        {...props}
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
        }}
      >
        <Typography variant="h6">{option.name}</Typography>
        <Typography>
          <em>Subject:</em>{" "}
          <Typography component="span">{option.subject}</Typography>
        </Typography>
        <Typography
          color="textSecondary"
          style={{
            textOverflow: "ellipsis",
            overflow: "hidden",
            height: "2em",
            lineHeight: "1em",
          }}
        >
          {option.body.plaintext}
        </Typography>
      </Box>
    );
  };

  const getOptionSelected = (option: any, value: any) => {
    return option.id === value.id;
  };

  const handleChange = (e: React.ChangeEvent<{}>, value: any) => {
    if (onChange) {
      onChange(e, value);
    }
  };

  if (loading) {
    return <Skeleton variant="rectangular" />;
  }
  return (
    <Autocomplete
      fullWidth
      onChange={handleChange}
      value={value}
      renderOption={renderOption}
      options={data?.getEmailTemplates || []}
      isOptionEqualToValue={getOptionSelected}
      getOptionLabel={(option: any) =>
        option && option.name ? option.name : ""
      }
      renderInput={(params: any) => (
        <TextField
          {...params}
          variant="standard"
          label="Email template"
          placeholder="Select an email template&hellip;"
        />
      )}
    ></Autocomplete>
  );
};

export default EmailTemplateAutocomplete;
